import ClipboardLabel from './ClipboardLabel';

export default ClipboardLabel;
